import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { MdOutlineInfo } from "react-icons/md";
import { CgArrowsShrinkH, CgArrowsShrinkV } from "react-icons/cg";
import { Link } from "react-router-dom";

const ComponentSousTitle = (props) => {
  const { t } = useTranslation();
  const { nom, children, popupInfo, overflowID, overflowDeplieAuDepart, idTagTixme, titleHref } =
    props;
  const [show, setShow] = useState(false);
  const [close, setClose] = useState(false);

  const overflowToggle = (overflowID) => {
    const overflowBloc = document.getElementById(overflowID);
    if (overflowBloc.classList.contains("overflowContent")) {
      overflowBloc.classList.remove("overflowContent");
      overflowBloc.classList.add("disableOverflowContent");
      document.getElementById("buttonDisableOverflowContent" + overflowID).classList.add("d-none");
      document.getElementById("buttonOverflowContent" + overflowID).classList.remove("d-none");
    } else {
      overflowBloc.classList.remove("disableOverflowContent");
      overflowBloc.classList.add("overflowContent");
      document
        .getElementById("buttonDisableOverflowContent" + overflowID)
        .classList.remove("d-none");
      document.getElementById("buttonOverflowContent" + overflowID).classList.add("d-none");
    }
  };

  return (
    <>
      <h2>
        <span className="pointJaune"></span>
        {children}
        {titleHref ? <Link to={titleHref}>{nom}</Link> : nom}
        {popupInfo && (
          <MdOutlineInfo
            className="ms-3"
            role="button"
            size="0.8em"
            onClick={() => setShow(!show)}
            id={idTagTixme ? "iconInformationProcess_" + idTagTixme : "cool"}
          />
        )}
        {overflowID && (
          <span onClick={() => overflowToggle(overflowID)} role="button" className="ms-2">
            {overflowDeplieAuDepart}
            <CgArrowsShrinkV
              className={overflowDeplieAuDepart == undefined ? "" : "d-none"}
              id={"buttonDisableOverflowContent" + overflowID}
            />
            <CgArrowsShrinkH
              className={overflowDeplieAuDepart == undefined ? "d-none" : ""}
              id={"buttonOverflowContent" + overflowID}
            />
          </span>
        )}
      </h2>
      <Modal size="lg" show={show} onHide={() => setShow(!show)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("public.pageInGovernance.modalTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: "pre-wrap" }}>{popupInfo}</Modal.Body>
      </Modal>
    </>
  );
};

export default ComponentSousTitle;
